import { Injectable } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';

@Injectable({
    providedIn: 'root'
})
export class DialogHelperService {
    getDialogConfig<TComponentData>(componentData: TComponentData, classesPrefix: string): MatDialogConfig<TComponentData> {
        const config: MatDialogConfig = {
            data: componentData,
            backdropClass: [`${classesPrefix}-dialog-backdrop`, 'aoc-dialog-backdrop-class'],
            panelClass: [`${classesPrefix}-dialog-panel`, 'aoc-dialog-panel'],
        };
        return config;
    }
}
